import { SecApp } from "./components/SecApp";
import GlobalStyles from "./styles/GlobalStyle";
import { DataContext } from "./contexts/DataContext";

import "./App.css";
import { useConfig } from "./contexts/ConfigContext";
import { CenterLoadingSpinner } from "./components/Spinners/LoadSpinner";
import { useState } from "react";
import FaviconLoader from "./helpers/FaviconLoader/FaviconLoader";
import { useTenant } from "./contexts/TenantService";
import { ThemeProvider } from "./theme/ThemeProvider";

function App() {
  const { configReady } = useConfig();
  const { tenantSvc } = useTenant();
  const [successUserName, setSuccessUserName] = useState("");
  const [successUserNameEdit, setSuccessUserNameEdit] = useState("");
  const [successUserNameProfile, setSuccessUserNameProfile] = useState("");

  const query = new URLSearchParams(window.location.search).get("brand_id");

  if (!configReady || !tenantSvc) {
    return <CenterLoadingSpinner />;
  }
  const bodyElement = document.body;
  bodyElement.className = `${tenantSvc?.tenantId} worldline`;

  const brandId = query;
  FaviconLoader(`${process.env.PUBLIC_URL}/static/images/${tenantSvc.tenantId}/favicon.png`);

  return (
    <ThemeProvider brandId={brandId}>
      <DataContext.Provider
        value={{
          successUserName,
          setSuccessUserName,
          successUserNameEdit,
          setSuccessUserNameEdit,
          successUserNameProfile,
          setSuccessUserNameProfile,
        }}
      >
        <GlobalStyles />
        <SecApp />
      </DataContext.Provider>
    </ThemeProvider>
  );
}
export default App;
